window.middysHawkSearchTemplates = window.middysHawkSearchTemplates || {};
window.middysHawkSearchTemplates.pageSize = `
    <style>
        .select2-container--default .select2-selection--single .select2-selection__arrow {
            display: none
        }

        .select2-container--default .select2-selection--single {
            border: 0
        }

        .select2-container--default .select2-selection--single .select2-selection__rendered {
            font-family: Lato;
            padding: 0 30px 0 15px;
            font-size: 16px;
            line-height: 28px;
            letter-spacing: .01em;
            color: #333;
            background: url(/images/arrow-down-grey.svg) no-repeat right calc(50% + 1px)
        }

        .select2-container--default.select2-container--open .select2-selection--single .select2-selection__rendered {
            color: #e6007e;
            background: url(/images/arrow-up-pink.svg) no-repeat right center;
            font-weight: 700
        }

        .select2-container--open .select2-dropdown--above,.select2-container--open .select2-dropdown--below,.select2-dropdown {
            box-shadow: 0 11px 15px rgba(0,0,0,.25);
            border-radius: 4px;
            border: 1px solid #d1d5db;
            z-index: 1100
        }

        .select2-container--default .select2-results__option--highlighted.select2-results__option--selectable,.select2-container--default .select2-results__option--selected {
            background-color: #fff;
            color: #e6007e
        }

        .select2-container--default .select2-results__option--highlighted[aria-selected=true]:not(.select2-results__option--selected) {
            color: #666;
            background-color: #f4f4f4
        }

        .select2-results__options {
            padding: 8px 0 12px
        }

        .select2-results__option {
            font-family: Lato;
            padding: 8px 15px 9px;
            font-weight: 400
        }

        @media screen and (max-width: 767px), print {
            .page-size {
                margin-top: 15px;
            }

            .select2-container .select2-selection--single {
                height: unset;
            }

            .select2-container--default .select2-selection--single .select2-selection__rendered, .select2-container--default.select2-container--open .select2-selection--single .select2-selection__rendered {
                font-size: 14px;
                line-height: 20px;
                padding: 12px 30px 12px 12px;
                background-position: calc(100% - 12px) center;
                background-size: 13px;
            }
        }
    </style>
    <div class="page-size">
        <select hawksearch-page-size>
            {{#each options}}
                {{#if selected}}
                    <option value="{{pageSize}}" selected>{{title}}</option>
                {{else}}
                    <option value="{{pageSize}}">{{title}}</option>
                {{/if}}
            {{/each}}
        </select>
    </div>
`;
